import { atom } from 'jotai';

import {
  createInventoryPeriodConfigAtom,
  updateInventoryPeriodConfigAtom,
} from '../_graphql/mutationInventoryPeriodConfig';
import { inventoryPeriodConfigQueryAtom } from '../_graphql/queryInventoryPeriodConfig';

import { $remoteInventoryPeriods } from './inventoryPeriodsList.state';

export type PeriodConfigForm = {
  periodType?: string;
  fiscalYearStartMonth?: number | null;
  allowStraddleCompletion?: boolean;
  straddleWindowPeriods?: number;
  requireStraddleApproval?: boolean;
};

export const DEFAULT_FORM = {
  periodType: 'CalendarMonth',
  allowStraddleCompletion: false,
  straddleWindowPeriods: 1,
  requireStraddleApproval: false,
} satisfies PeriodConfigForm;

export const $isConfigDialogOpen = atom(false);

export const $periodConfigForm = atom<PeriodConfigForm>({ ...DEFAULT_FORM });

export const $periodConfigFormConstraints = atom((get) => {
  const form = get($periodConfigForm);

  const isFiscalPeriod = form.periodType === 'FiscalPeriod';
  const hasFiscalMonth = !!form.fiscalYearStartMonth;

  const canSubmit = !!form.periodType && (!isFiscalPeriod || hasFiscalMonth);

  return {
    isFiscalPeriod,
    showStraddleFields: !!form.allowStraddleCompletion,
    canSubmit,
  };
});

export const $resetPeriodConfigForm = atom(null, (_get, set) => {
  set($periodConfigForm, { ...DEFAULT_FORM });
});

export const $remoteInventoryPeriodConfig = inventoryPeriodConfigQueryAtom(
  () => ({}),
);

export const $createPeriodConfig = createInventoryPeriodConfigAtom({
  onSuccess: (get) => {
    get($remoteInventoryPeriodConfig).refetch();
    get($remoteInventoryPeriods).refetch();
  },
});

export const $updatePeriodConfig = updateInventoryPeriodConfigAtom({
  onSuccess: (get) => {
    get($remoteInventoryPeriodConfig).refetch();
    get($remoteInventoryPeriods).refetch();
  },
});
